import { render, staticRenderFns } from "./EmployeeShiftModal.vue?vue&type=template&id=3173d52e&scoped=true"
import script from "./EmployeeShiftModal.vue?vue&type=script&lang=js"
export * from "./EmployeeShiftModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3173d52e",
  null
  
)

export default component.exports